import { render } from "./FigureBlock.vue?vue&type=template&id=7c2539c0"
import script from "./FigureBlock.vue?vue&type=script&lang=js"
export * from "./FigureBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__